// extracted by mini-css-extract-plugin
export default {"grid":"qGmO9t","container":"_E0ugR","column":"WKJ4dV","row":"BCDzLu"};